import { CoinShowerEvent } from '../model/BaseGameModel'
import { CollectionEvent } from '../model/HoldAndWinModel'

/**
 * Manager to keep track of the order of events between states
 * @author Adam Drake - <adam.drake@1x2network.com>
 * @version 1.0.0
 */
export class EventManager {
    private events: Array<CoinShowerEvent | CollectionEvent> = []

    public setEvents(events: Array<CoinShowerEvent | CollectionEvent>) {
        this.events = [...events]
    }

    public peek(): CoinShowerEvent | CollectionEvent | undefined {
        return this.events[0]
    }

    public nextEvent(): CoinShowerEvent | CollectionEvent | undefined {
        return this.events.shift()
    }
}
